import React, { useEffect, useState, useRef } from 'react';
import { Box, Chip } from '@mui/material';
import Alert from '@mui/material/Alert';
import DateFnsAdapter from '@date-io/date-fns';
import { connect } from 'react-redux';
import shortid from 'shortid';
import RegularOrderbook from './components/RegularOrderbook';
import OrdersService from '../../../../../services/ordersService';
import { useServiceFetchApis } from '../../../../../shared/hooks/useServiceFetchApis';
import { FilterKey, FilterGroup } from '../MergedOrderList/styling/styledComponents';
import { buildUrlFromParams, collectParamsFromSettings } from '../../../../../shared/helpers/createUrlFromParams';
import { getSelectedClientInputValue } from '../../../../../redux/selectors/clientSearchSelectors';
const mappedExchanges = {
    FakeKraken: 'fake_kraken',
    FakeBitstamp: 'fake_bitstamp',
};
const dateFns = new DateFnsAdapter();
const renderFilterParams = (filterParams, paramKeys) => {
    if (filterParams === null) {
        return null;
    }
    return (React.createElement(Box, { p: filterParams ? 2 : 0 },
        React.createElement("div", null, paramKeys.map((key) => (React.createElement(FilterGroup, { key: key },
            React.createElement(FilterKey, null, key === 'exchange_code' ? 'exchange' : key),
            ":",
            ' ',
            filterParams[key].map((param) => (React.createElement(Chip, { key: shortid.generate(), size: 'small', color: 'default', label: key === 'from' || key === 'to' ? dateFns.format(new Date(param), 'dd/MM/yyyy') : param, style: { marginRight: 8 } })))))))));
};
/* eslint-disable @typescript-eslint/no-explicit-any, react/jsx-indent */
const OrderBooks = ({ settings, widgetKey, selectedClient, regularPage, setRegularPage, selectedCustomer, clientInfo, masterTenant, }) => {
    const [total, setTotal] = useState(0);
    const [settingsUrl, setSettingUrl] = useState('');
    const [paramKeys, setParamsKeys] = useState([]);
    const [selectedExchange, setSelectedExchange] = useState('');
    const [service, setService] = useState(null);
    const [regularOrders, setRegularOrders] = useState([]);
    const [filterParams, setFilterParams] = useState(null);
    const exchangeRef = useRef('');
    const { data } = useServiceFetchApis(service, settingsUrl, 4000);
    const handlePageChange = (event, page) => {
        setRegularPage(page);
    };
    const handleExchangeChange = (exchange) => {
        setSelectedExchange(exchange);
        setRegularPage(0);
    };
    const handleSettingsChange = (widgetSettings, customer, page, exchange, selectedClient) => {
        const params = collectParamsFromSettings(widgetSettings, `${widgetKey}Regular`);
        const sentExchange = mappedExchanges[exchange] || exchange;
        const selectedExchangeParams = {
            exchange_code: [sentExchange],
        };
        const sentParams = exchange !== '' ? selectedExchangeParams : params;
        const client = !masterTenant ? { value: (clientInfo === null || clientInfo === void 0 ? void 0 : clientInfo.code) || '', label: '' } : selectedClient;
        const settingUrl = buildUrlFromParams(sentParams, customer, page, false, client);
        setSettingUrl(settingUrl);
    };
    useEffect(() => {
        const serviceInstance = new OrdersService({
            url: '',
            method: 'get',
        }, '/orders');
        setService(serviceInstance);
    }, []);
    useEffect(() => {
        if (data) {
            setRegularOrders(data.records);
            setTotal(data.total);
        }
    }, [data]);
    useEffect(() => {
        let exchange = '';
        if (exchangeRef.current !== selectedExchange) {
            exchangeRef.current = selectedExchange;
            exchange = selectedExchange;
        }
        else {
            setSelectedExchange('');
        }
        if (settings && settings.length) {
            handleSettingsChange(settings, selectedCustomer, regularPage + 1, exchange, selectedClient);
        }
    }, [settings, selectedCustomer, regularPage, selectedExchange, selectedClient]);
    useEffect(() => {
        const params = collectParamsFromSettings(settings, `${widgetKey}Regular`);
        const keys = Object.keys(params);
        setParamsKeys(keys);
        setFilterParams(params);
    }, [settings, widgetKey]);
    return (React.createElement("div", null,
        filterParams ? renderFilterParams(filterParams, paramKeys) : null,
        React.createElement("div", null, !regularOrders.length ? (React.createElement(Box, { p: 1 },
            React.createElement(Alert, { severity: 'info', variant: 'outlined' }, "No items found"))) : (React.createElement(RegularOrderbook, { total: total, pageRegular: regularPage, regularOrders: regularOrders, onPageChange: handlePageChange, handleExchangeChange: handleExchangeChange })))));
};
const mapStateToProps = (state) => ({
    selectedClient: getSelectedClientInputValue(state),
    selectedCustomer: state.customers.selectedCustomer,
    clientInfo: state.client.clientInfo,
    masterTenant: state.client.masterTenant,
});
export default connect(mapStateToProps)(OrderBooks);
